var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutlinedFilltick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34488 4.31457L8.57541 0.689951C8.83927 0.261184 9.30668 0 9.81013 0C10.6987 0 11.3782 0.79201 11.243 1.67022L11 3.25C10.7371 4.95887 12.0593 6.5 13.7882 6.5H14.478C17.015 6.5 18.6651 9.16987 17.5305 11.439L16.382 13.7361C15.535 15.43 13.8037 16.5 11.9098 16.5H9C7.65211 16.5 6.45994 15.8333 5.73525 14.8117C5.74501 14.7091 5.75 14.6051 5.75 14.5V6.5C5.75 6.169 5.70052 5.84955 5.60855 5.54866C5.78577 5.22312 6.02173 4.83968 6.34488 4.31457Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 14.5C4.25 15.4665 3.4665 16.25 2.5 16.25C1.5335 16.25 0.75 15.4665 0.75 14.5V6.5C0.75 5.5335 1.5335 4.75 2.5 4.75C3.4665 4.75 4.25 5.5335 4.25 6.5V14.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlinedFilltick);
export default __webpack_public_path__ + "static/media/outlined_filltick.27ff5f6a24ea2c05c238ba5e7e51d85c.svg";
export { ForwardRef as ReactComponent };